import { helper } from '@ember/component/helper';

export function enumOption([theEnum, value]) {
  return theEnum.values.find((option) => option.value === value);
}

export default helper(enumOption);
